// import axios, { HttpStatusCode } from "axios";

// const authToken = localStorage.getItem('auth_token')

// const apiFetcher = axios.create({
//     baseURL: process.env.REACT_APP_URL,
//     headers: {
//         'Authorization': `Bearer ${authToken}`,
//     }
// })

// apiFetcher.interceptors.response.use(function (response) {
//     if (response.status === HttpStatusCode.Ok) {
//         return response;
//     } else if (response.status === HttpStatusCode.Forbidden) {
//         return Promise.reject("Forbidden");
//     } else if (response.status === HttpStatusCode.BadRequest) {
//         return Promise.reject("Bad Request");
//     } else if (response.status === HttpStatusCode.NotFound) {
//         return Promise.reject("Not Found");
//     } else if (response.status === HttpStatusCode.InternalServerError) {
//         return Promise.reject("Internal Server Error");
//     } else if (response.status === HttpStatusCode.ServiceUnavailable) {
//         return Promise.reject("Service Unavailable");
//     } else if (response.status === HttpStatusCode.Unauthorized) {
//         return Promise.reject("Unauthorized");
//     }
// }, function (error) {
//     return Promise.reject(error.response.data.message);
// });

// export default apiFetcher;

import axios, { HttpStatusCode } from 'axios';
import { access_token } from '../test/TestCases';
import packageJson from '../../package.json';

const apiFetcher = axios.create({
    baseURL: process.env.REACT_APP_URL,
});
const APP_VERSION = packageJson?.version;

export const isDashboardLogin = () => {
    if (typeof window !== 'undefined') {
        return Boolean(localStorage.getItem('from_dashboard'));
    }
    return false;
};

export const getAccessToken = () => {
    if (typeof window !== 'undefined') {
        return access_token || localStorage.getItem('auth_token');
    }
    return access_token || null;
};

export const getAppLanguage = () => {
    const lang = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
    return lang === 'en' ? 'en' : 'da';
};

// Add request interceptor to include Authorization header
apiFetcher.interceptors.request.use(
    (config) => {
        const authToken = access_token || localStorage.getItem('auth_token');
        config.headers['X-App-Platform'] = 'web';
        config.headers['X-App-Version'] = APP_VERSION;
        config.headers['x-App-lang'] = getAppLanguage();
        if (authToken) {
            config.headers['Authorization'] = `Bearer ${authToken}`;
        }
        if (isDashboardLogin()) {
            config.headers['x-login-from'] = 'dashboard';
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Response interceptor
apiFetcher.interceptors.response.use(
    (response) => {
        // if (response.status === HttpStatusCode.Ok) {
        //     return response;
        // } else {
        //     return Promise.reject(`Error: ${response.status}`);
        // }
        if (response.status === HttpStatusCode.Ok) {
            return response;
        } else if (response.status === HttpStatusCode.Forbidden) {
            return Promise.reject('Forbidden');
        } else if (response.status === HttpStatusCode.BadRequest) {
            return Promise.reject('Bad Request');
        } else if (response.status === HttpStatusCode.NotFound) {
            return Promise.reject('Not Found');
        } else if (response.status === HttpStatusCode.InternalServerError) {
            return Promise.reject('Internal Server Error');
        } else if (response.status === HttpStatusCode.ServiceUnavailable) {
            return Promise.reject('Service Unavailable');
        } else if (response.status === HttpStatusCode.Unauthorized) {
            return Promise.reject('Unauthorized');
        }
    },
    (error) => {
        if (error.response.status === HttpStatusCode.Forbidden) {
            localStorage.clear();
            // Already on the login page: assigning href to '/' reloads and loops.
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
            return Promise.reject('Forbidden');
        }
        return Promise.reject(error);
    },
);

export default apiFetcher;
